/**
 * Generates a unique ID for a marker based on its latitude, longitude, and name.
 *
 * @param lat - The latitude of the marker. Expected to be a number representing the geographical coordinate.
 * @param lng - The longitude of the marker. Expected to be a number representing the geographical coordinate.
 * @param name - The name of the marker. Expected to be a string; spaces will be replaced with underscores in the generated ID.
 * @returns {string} - A unique ID for the marker in the format `marker-{lat}-{lng}-{name}`.
 */
export function getIdFromMarker(lat: number, lng: number, name: string) {
  return `marker-${lat}-${lng}-${encodeURIComponent(name)}`;
}
